import { ReactNode } from 'react';

import { Text } from '../../../cdl/Text/Text';
import { Box } from '../../../common/ui/Box';

interface StatsItemProps {
    item: ReactNode;
    description: string;
}

export const StatsItem = ({ item, description }: StatsItemProps) => {
    return (
        <Box>
            <Text fontSize={24} fontWeight={700} as="h4">
                {item}
            </Text>
            <Text color="foreground.subtle" marginTop={6} as="h5">
                {description}
            </Text>
        </Box>
    );
};
